import { render, staticRenderFns } from "./RuntimeModeIndicator.vue?vue&type=template&id=4c456dcb&scoped=true"
import script from "./RuntimeModeIndicator.vue?vue&type=script&lang=js"
export * from "./RuntimeModeIndicator.vue?vue&type=script&lang=js"
import style0 from "./RuntimeModeIndicator.vue?vue&type=style&index=0&id=4c456dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c456dcb",
  null
  
)

export default component.exports